export default {
  author: {
    id: 'buying_guide_author',
    defaultMessage: 'Written by {name}, {position}',
  },
}
